const transactions = {
  transactionsList: {
    pageTitle: "Transactions",
    transaction: "Transaction",
    transactions: "Transactions",
    tableHeader: {
      companyName: "Company Name",
      paymentReason: "Payment Reason",
      transactionId: "Transaction ID",
      paymentAmount: "Payment Amount",
      transactionDate: "Transaction Date"
    },
    notTransactionsFound: "There are no transactions yet",
    noSearchResults:
      "There is no search result that matches the entered data.",
    searchPlaceholder: "Search by company name & transaction id",
    filters: {
      paymentReason: "Payment Reason",
      status: "Transaction Status",
      succeeded: "Succeeded",
      failed: "Failed",
      paymentReasonSearchPlaceholders: "Search by payment Reason"
    }
  }
};

export default transactions;
